// Cookie consent storage + GA4 Consent Mode wiring.
export const CONSENT_KEY = "eminence_cookie_consent_v1";

export function getConsent() {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function hasAnalyticsConsent() {
  const c = getConsent();
  return !!(c && c.analytics);
}

export function hasMarketingConsent() {
  const c = getConsent();
  return !!(c && c.marketing);
}

// Push the current choice into GA4 Consent Mode. Called on load and on change.
export function applyConsentToGtag(c) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: c && c.analytics ? "granted" : "denied",
      ad_storage: c && c.marketing ? "granted" : "denied",
      ad_user_data: c && c.marketing ? "granted" : "denied",
      ad_personalization: c && c.marketing ? "granted" : "denied",
    });
  }
}

export function saveConsent(choice) {
  const val = {
    analytics: !!choice.analytics,
    marketing: !!choice.marketing,
    decided: true,
    ts: Date.now(),
  };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(val));
  } catch {}
  applyConsentToGtag(val);
  return val;
}
